import React from "react"
import { FormattedMessage } from "react-intl"

import { isFeatureEnabled } from "config/feature-flags"
import { ModuleContainer } from "components/ModuleContainer"
import { unCollapseSideBar } from "context/applicationContext"
import PromotionBanner from "components/Shared/PromotionBanner"
import { useMedalliaFeedback } from "components/Shared/Hooks/useMedalliaFeedback"
import { submodules } from "./submodules"
import Welcome from "components/Shared/Modals/Welcome"

const Transactional: React.FC = () => {
	unCollapseSideBar()
	useMedalliaFeedback()

	return (
		<React.Fragment>
			<ModuleContainer
				submodules={submodules}
				className="module-container"
				bannerContent={
					isFeatureEnabled("promotionBanner") && <PromotionBanner />
				}
				titleContent={
					<FormattedMessage id={"phronesis.menu.option.transactional.title"} />
				}
			/>
			<Welcome />
		</React.Fragment>
	)
}

export default Transactional
